import { openBlock as e, createElementBlock as l, createElementVNode as t } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, n = /* @__PURE__ */ t("path", {
  fill: "#F0F0F0",
  d: "M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20Z"
}, null, -1), c = /* @__PURE__ */ t("path", {
  fill: "#A2001D",
  d: "M20 0C11.732 0 4.636 5.018 1.59 12.174h36.82C35.364 5.018 28.268 0 20 0Z"
}, null, -1), s = /* @__PURE__ */ t("path", {
  fill: "#496E2D",
  d: "M20 40c8.268 0 15.364-5.018 18.41-12.174H1.59C4.636 34.982 11.732 40 20 40Z"
}, null, -1), i = /* @__PURE__ */ t("path", {
  fill: "#0052B4",
  d: "M39.311 14.783H.689A20.021 20.021 0 0 0 0 20c0 1.805.24 3.554.689 5.217h38.622A19.99 19.99 0 0 0 40 20c0-1.805-.24-3.554-.689-5.217Z"
}, null, -1), d = [
  n,
  c,
  s,
  i
];
function h(_, r) {
  return e(), l("svg", o, [...d]);
}
const f = { render: h };
export {
  f as default,
  h as render
};
